exports = module.exports = require("../../../../../../../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".customer-info__pax-title{font-weight:200;font-size:20px;color:#000;text-transform:capitalize}.customer-info__gender-radio-group .v-input--selection-controls{margin-top:0}", ""]);

// exports
